/**
 * NetworkErrorBanner — 네트워크 오류 배너 (재연결/취소)
 */

import { WifiOff, RefreshCw, X } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export interface NetworkErrorBannerProps {
  message?: string;
  onRetry?: () => void;
  onDismiss?: () => void;
  className?: string;
}

export function NetworkErrorBanner({
  message = "네트워크 연결에 문제가 발생했습니다.",
  onRetry,
  onDismiss,
  className,
}: NetworkErrorBannerProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 border-b border-signal-danger/20 bg-signal-danger/5 px-4 py-2.5",
        className,
      )}
      role="alert"
    >
      <WifiOff className="size-4 shrink-0 text-signal-danger" />
      <p className="flex-1 text-[12px] text-signal-danger">{message}</p>
      <div className="flex items-center gap-1">
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="flex items-center gap-1 rounded-lg px-2.5 py-1 text-[11px] font-medium text-signal-danger hover:bg-signal-danger/10 transition-colors"
          >
            <RefreshCw className="size-3.5" />
            <span>재시도</span>
          </button>
        )}
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="flex size-6 items-center justify-center rounded text-signal-danger hover:bg-signal-danger/10 transition-colors"
          >
            <X className="size-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
